import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from "@material-ui/core/CircularProgress";
 // import {NotificationManager} from "react-notifications";
import BBLogo from "../assets/images/BreachBits_full_medres_transparent_fordarkbackground.png"

import {
   setInitUrl,
  showAuthLoader,
  userSignIn,
} from 'actions/Auth';
// import nprogress from "nprogress";
import {showBBNotification} from "../util/bbHelpers";
import {INFO,} from "../constants/ActionTypes";
import qs from "qs";

var pjson = require('../../package.json'); //to display version number

const SignIn = (props) => {

  //variables grabbed form the URL parameters
  const {location} = props;

  const urlTemporaryPW = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).t : null;
  const emailFromUrl = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).u : null;
  // const userMessage = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).message : null;

  const [email, setEmail] = useState(emailFromUrl ? emailFromUrl : null);
  const [hadFirstRender, setHadFirstRender] = useState(false);
  const [password, setPassword] = useState(urlTemporaryPW ? urlTemporaryPW : null);
  const dispatch = useDispatch();
  const {token, mfaSessionToken, authUser, initURL} = useSelector(({auth}) => auth);
  const {didJustResetPW, didJustEmailConfirmCode} = useSelector(({auth}) => auth.appMisc);
  const {loader} = useSelector(({auth}) => auth);

  console.log("initURL on the sign in page", initURL, "& props.history.location.search", props.history.location.search);

  //stop the page loader
  // useState(nprogress.start());

  // useEffect(()=>{
  //   console.log("Tokens updated---refreshToken is", bbShortenString(refreshToken, 40, true), "and current token is", bbShortenString(token,40,true), "mfaSessionToken is", bbShortenString(mfaSessionToken,40,true),);
  // }, [token, refreshToken, mfaSessionToken])


  useEffect(() => {
    // nprogress.done();

    // console.log("TOKEN CHECK. TOKEN IS", token, "local:", localStorage.getItem("token"))
    // console.log("REFRESH TOKEN CHECK. REFRESH TOKEN IS", refreshToken, "local:", localStorage.getItem("refreshToken"))
    // console.log("MFA TOKEN CHECK. MFA TOKEN IS", mfaSessionToken, "local:", localStorage.getItem("mfaSessionToken"))

    //if not fully logged in but an MFA token is present, go to the MFA page
    if (token === null && mfaSessionToken != null) {
      console.log("MFA Token is set, redirecting to MFA code entry page.")
      props.history.push('/MFA');
    }
    //if there is a token (user is logged in) but the user has not verified their email
    // if(token !== null
    //     && (authUser && authUser.user && !authUser.user.is_activated)
    //     && (authUser && authUser.security && !authUser.security.mfa_enabled)){
    //   props.history.push(`/addMFA`);
    // }

    //if user is logged in and they are not associated with a customer push to confirm New customer page
    if(token !== null
        && (authUser
            && authUser.customers
            && Array.isArray(authUser.customers)
            && authUser.customers.length === 0)){
      props.history.push(`/confirmNew`);
    }


    //if there is a token set (if user is logged in), redirect to home page
    //TODO: Update to leverage refresh_token instead
    if (token !== null && authUser && authUser.user.is_active) {
      // console.log("From signin page, redirecting to /")
      props.history.push('/');
    }

    if (authUser && !authUser.user.is_active){
      showBBNotification(INFO,
          <IntlMessages id={"event.userInactive.title"}/>,
          <IntlMessages id={"event.userInactive.detail"}/>,
          true);
    }
    // return () => nprogress.start();

    if (!hadFirstRender && password && password !== "" && password === urlTemporaryPW) {
      //console.log("password pasted:", password, "urlTemporaryPW:", urlTemporaryPW);
      showBBNotification("info", "Password Pasted","Your temporary password has been automatically pasted into the password field.", true);
      setHadFirstRender(true);
    }

  }, [props.history, dispatch, token, authUser, mfaSessionToken]);

  const onFormSubmit = e => {
    e.preventDefault();
    //if user had set a temporary password
    if (urlTemporaryPW || didJustResetPW || didJustEmailConfirmCode) {
      setInitUrl('/')
    }
    dispatch(showAuthLoader());
    // console.log("About to signin with email, ", email, "password", password);
    dispatch(userSignIn({email, password}));
    //unset the password for security
    setPassword(null);
  }

  return (
      <React.Fragment>
    <div
      className="app-login-container d-flex justify-content-center align-items-center animated fadeIn animation-duration-15">
      <div className="app-login-main-content">


        <div className="app-logo-content d-flex align-items-center justify-content-center">

          <a className="logo-lg" href="https://www.breachbits.com" title="BreachBits">
            <img src={BBLogo} alt="BreachBits Logo" title="Learn more about BreachBits at breachbits.com"/>
          </a>
          {/*<div className="ellipse-shape"/>*/}
          {/*<div className="ellipse-shape2"/>*/}
          {/*<div className="ellipse-shape3"/>*/}
        </div>


        <div className="app-login-content">
          <div className="app-login-header mb-4">
            <h1><IntlMessages id="appModule.signIn"/></h1>
          </div>

          <div className="app-login-form">
            <form onSubmit={onFormSubmit}>
              <fieldset>
                <TextField
                    id={"username_field"}
                  label={<IntlMessages id="appModule.username"/>}
                  fullWidth
                  onChange={(event) => setEmail(event.target.value)}
                  defaultValue={email}
                  margin="normal"
                  className="mt-1 my-sm-3"
                />
                <TextField
                    id={"password_field"}
                  type="password"
                  label={<IntlMessages id="appModule.password"/>}
                  fullWidth
                  onChange={(event) => setPassword(event.target.value)}
                  defaultValue={password}
                  margin="normal"
                  className="mt-1 my-sm-3"
                />

                <div className="mb-3 d-flex align-items-center justify-content-between">
                  <Button type="submit" variant="contained" color="primary" id={"login_submit"}>
                    <IntlMessages id="form.submit"/>
                  </Button>

                  <Link to="/register">
                    <IntlMessages id="appModule.register"/>
                  </Link>
                  <br/>
                  <Link to="/resetpassword">
                    <IntlMessages id="appModule.resetPassword.title"/>
                  </Link>



                  {/*TODO: Reenable this once we allow self-signup*/}
                  {/*<Link to="/signup">*/}
                  {/*  <IntlMessages id="signIn.signUp"/>*/}
                  {/*</Link>*/}
                </div>

              </fieldset>
            </form>
          </div>
          <div id={"version"}> v. {`${pjson.version}`}</div>
        </div>

      </div>


      {
        loader &&
        <div className="loader-view">
          <CircularProgress/>
        </div>
      }
      {/*{showMessage && NotificationManager.error(alertMessage, "Login Error", 10000)}*/}
      {/*<NotificationContainer/>*/}

    </div>
        <div className="break"> </div>
        {/*<div className={"app-login-subtitle"}>*/}
        {/*  <img src={require("assets/images/turn-the-tide-dark.png")} alt="breachbits" title="breachbits"/>*/}
        {/*</div>*/}
      </React.Fragment>
  );
};


export default SignIn;
